import { useSelector } from 'src/hooks/useSelector';

const useSupportContacts = () => {
    const contactPhones = useSelector(({ contactPhones }) => contactPhones);
    return contactPhones;
};

export { useSupportContacts };
